import { createApiClient } from '@/infrastructure/api/client'
import { RegionRepository } from '@/infrastructure/repositories/region.repository'
import { RegionService } from '@/domain/services/region.service'

let cachedService: RegionService | null = null

/**
 * Композабл для сервісу регіонів (regions).
 * Використовує спільний екземпляр API-клієнта та сервісу.
 */
export function useRegionService(): RegionService {
  if (!cachedService) {
    const config = useRuntimeConfig()
    const apiClient = createApiClient({
      baseUrl: config.public.NUXT_APP_LANDING_API,
    })
    const regionRepository = new RegionRepository(apiClient)
    cachedService = new RegionService(regionRepository)
  }
  return cachedService
}
